// 借鉴
// https://github.com/szimek/signature_pad
import Utils from '@packages/utils/utils.js';
import EventBus from '@packages/utils/eventBus.js';
import Extends from '@packages/utils/extends.js';
var touchEvents = {
  start: Utils.support.touch ? 'touchstart' : 'mousedown',
  move: Utils.support.touch ? 'touchmove' : 'mousemove',
  end: Utils.support.touch ? 'touchend' : 'mouseup'
};
var isTouchEvent = false;
var isTouch = false;
var Signature = function (el, options) {
  this.wrapper = (typeof el === 'string' ? document.querySelector(el) : el);
  var defaults = {
    lineWidth: 3,
    penColor: '#000',
    backgroundColor: '#FFF',
    placeholder: '请在白色区域内 横向签名',
    onInit: Utils.noop,
    onBegin: Utils.noop,
    onUpdate: Utils.noop,
    onEnd: Utils.noop
  }
  this.options = defaults;
  Extends(this.options, options);
  this.unique = this.options.unique || Utils.getUnique();
  this.touches = {};
  this.clearPlaceholder = false;
  this.isPainted = false;
  this._init();
}
Signature.prototype = {
  _init: function () {
    var self = this;
    self._createCanvas();
    self.setPlaceholder();
    self.observer = EventBus.create(self.unique);
    self._addEvent();
    self.observer.emit('onInit');
  },
  _createCanvas: function () {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = document.createElement('canvas');
    var _ctx = _canvas.getContext('2d');
    _wrapper.appendChild(_canvas);
    self._canvas = _canvas;
    self._ctx = _ctx;
    self._setCanvas();
  },
  _setCanvas: function () {
    var self = this;
    var _wrapper = self.wrapper;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    var _options = self.options;
    _canvas.width = _wrapper.clientWidth;
    _canvas.height = _wrapper.clientHeight;
    _ctx.lineWidth = _options.lineWidth;
    _ctx.strokeStyle = _options.penColor;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
    self.rect = _canvas.getBoundingClientRect();
  },
  _addEvent: function () {
    var self = this;
    self._canvas['addEventListener'](touchEvents.start, this, false);
    self._canvas['addEventListener'](touchEvents.move, this, false);
    self._canvas['addEventListener'](touchEvents.end, this, false);
    window['addEventListener']('resize', this, false);
    for (var item in self.options) {
      if (item.indexOf('on') === 0) {
        if (self.options[item] instanceof Function) {
          (function (item, _self) {
            _self.observer.on(item, function () {
              _self.options[item].apply(_self, Array.prototype.slice.call(arguments));
            });
          })(item, self)
        }
      }
    }
  },
  _onTouchStart: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    isTouchEvent = (e.type === 'touchstart');
    var touch = isTouchEvent ? e.touches[0] : e;
    isTouch = true;
    self.clearPlaceholder || self.clear();
    self.clearPlaceholder = true;
    self._strokeBegin(touch);
    self.isPainted = true;
    e.preventDefault();
  },
  _onTouchMove: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    if (!isTouch && e.type === 'mousemove') {
      e.preventDefault();
      return;
    }
    var touch = isTouchEvent ? e.touches[0] : e;
    self._strokeUpdate(touch);
    e.preventDefault();
  },
  _onTouchEnd: function (e) {
    var self = this;
    if (e.originalEvent) e = e.originalEvent;
    var touch = isTouchEvent ? e.touches[0] : e;
    self._strokeEnd(touch);
    isTouch = false;
    e.preventDefault();
  },
  _onResize: function (e) {
    var self = this;
    self._setCanvas();
    self.reset();
  },
  _strokeBegin: function (touch) {
    var self = this;
    self.touches.startX = touch.clientX;
    self.touches.startY = touch.clientY;
    self._strokeUpdate(touch);
    self.observer.emit('onBegin', touch);
  },
  _strokeUpdate: function (touch) {
    var self = this;
    var _touches = self.touches;
    _touches.currentX = touch.clientX;
    _touches.currentY = touch.clientY;
    var start = self._createPoint(_touches.startX, _touches.startY);
    var end = self._createPoint(_touches.currentX, _touches.currentY);
    self._drawLine(start, end);
    _touches.startX = touch.clientX;
    _touches.startY = touch.clientY;
    self.observer.emit('onUpdate', touch);
  },
  _strokeEnd: function (touch) {
    var self = this
    self.observer.emit('onEnd', touch);
  },
  _createPoint: function (x, y) {
    var self = this;
    var _offset = self.rect;
    return {
      x: x - _offset.left,
      y: y - _offset.top
    }
  },
  _drawLine: function (start, end) {
    var self = this;
    var _ctx = self._ctx;
    _ctx.beginPath();
    _ctx.moveTo(start.x, start.y);
    _ctx.lineTo(end.x, end.y);
    _ctx.closePath();
    _ctx.stroke();
  },
  handleEvent: function (e) {
    var self = this;
    switch (e.type) {
      case 'touchstart':
        self._onTouchStart(e);
        break;
      case 'touchmove':
        self._onTouchMove(e);
        break;
      case 'touchend':
        self._onTouchEnd(e);
        break;
      case 'mousedown':
        self._onTouchStart(e);
        break;
      case 'mousemove':
        self._onTouchMove(e);
        break;
      case 'mouseup':
        self._onTouchEnd(e);
        break;
      case 'resize':
        this._onResize(e);
        break;
    }
  },
  setPlaceholder: function (placeholder) {
    var self = this;
    var _ctx = self._ctx;
    var _canvas = self._canvas;
    _ctx.font = '300 15px PingFang SC';
    _ctx.textAlign = 'center';
    _ctx.textBaseline = 'middle';
    _ctx.fillStyle = '#ccc';
    placeholder = placeholder || self.options.placeholder;
    _ctx.fillText(self.options.placeholder, _canvas.width / 2, _canvas.height / 2);
  },
  clear: function () {
    var self = this;
    var _canvas = self._canvas;
    var _ctx = self._ctx;
    _ctx.fillStyle = self.options.backgroundColor;
    _ctx.clearRect(0, 0, _canvas.width, _canvas.height);
    _ctx.fillRect(0, 0, _canvas.width, _canvas.height);
  },
  reset: function () {
    var self = this;
    self.clear();
    self.clearPlaceholder = false;
    self.isPainted = false;
    self.setPlaceholder();
  },
  toImage: function (type, quality) {
    var self = this;
    if (!self.isPainted) {
      return;
    }
    type = type || 'image/png';
    quality = quality || 0.92;
    return self._canvas.toDataURL(type, quality);
  }
}

export default Signature;



// WEBPACK FOOTER //
// ./packages/components/signature/signature.js